import React, { useCallback, useEffect, useState } from 'react'
import { toast } from 'sonner';
import { Button, Container, Spinner } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import PropertySelectComponent from './breakfast/PropertySelectComponent';
import RoomSelectComponent from './breakfast/RoomSelectComponent';
import BasedOnComponent from './breakfast/BasedOnComponent';
import DateRangePickerComponent from './breakfast/DateRangePickerComponentV2';
import { FilterSchema, FilterSchemaType } from '../../../services/breakfast-report/schema/BookingSchema';
import useBooking from '../../../services/breakfast-report/hooks/useBooking';
import BreakfastTableReport from './breakfast/BreakfastTableReport';
import SkeletonTable from './breakfast/SkeletonTable';

const BreakfastReportComponent: React.FC = () => {
    const { control, handleSubmit, formState: { errors }, setValue } = useForm<FilterSchemaType>({
        resolver: zodResolver(FilterSchema),
        defaultValues: {
            filter: {
                property_id: "",
                base_on: "created_reservation",
                start_date: "",
                end_date: "",
                room_type_id: "",
            },
        },
    });

    // State untuk menyimpan filter yang akan digunakan saat fetching
    const [filter, setFilter] = useState<FilterSchemaType["filter"]>({
        property_id: "",
        base_on: "created_reservation",
        start_date: "",
        end_date: "",
        room_type_id: "",
    });

    const { data: breakfastBooking, isFetching: isFetchingBreakfastBooking } = useBooking({
        filter: filter,
    });

    // Fungsi tunggal untuk menangani submit
    const onSubmit = useCallback(
        (data: FilterSchemaType) => {
            console.log('data', data);

            let updatedFilter = { ...data.filter };

            setFilter(updatedFilter);
        },
        [setFilter] // Dependensi untuk mencegah pembuatan ulang yang tidak perlu
    );

    // Toast notifikasi saat data berhasil di-load
    useEffect(() => {
        if (!isFetchingBreakfastBooking && breakfastBooking) {
            toast.success('Breakfast report data loaded successfully.');
        }
    }, [isFetchingBreakfastBooking, breakfastBooking]);

    return (
        <Container fluid className="dashboard-content">
            <form onSubmit={handleSubmit((data) => onSubmit(data))}>
                <div className="d-flex flex-column flex-md-row justify-content-between gap-4">
                    {/* Kiri: Filter Components */}
                    <div className="d-flex flex-column flex-md-row gap-3 w-100">
                        <div className="w-100">
                            <PropertySelectComponent setValue={setValue} />
                        </div>

                        <div className="w-100">
                            <RoomSelectComponent control={control} errors={errors} setValue={setValue} />
                        </div>

                        <div className="w-100">
                            <BasedOnComponent control={control} errors={errors} setValue={setValue} />
                        </div>
                    </div>

                    {/* Kanan: Date Range & Submit */}
                    <div className="d-flex flex-column flex-md-row gap-3 w-100">
                        <div className="d-flex flex-column gap-2 w-100">
                            <DateRangePickerComponent control={control} errors={errors} setValue={setValue} />
                            <Button variant="warning" type="submit" disabled={isFetchingBreakfastBooking}>
                                {isFetchingBreakfastBooking ? <><Spinner animation="border" size="sm" className="me-2" />Loading...</> : 'Show Breakfast Report'}
                            </Button>
                        </div>
                    </div>
                </div>
            </form>
            {isFetchingBreakfastBooking && <SkeletonTable columns={10} rows={10} />}
            {!isFetchingBreakfastBooking && breakfastBooking && (
                <>
                    <BreakfastTableReport data={breakfastBooking} />
                </>
            )}
        </Container>
    )
}

export default BreakfastReportComponent
